import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';

main();

function main() {
    const $highestQualitySlider = document.querySelector<HTMLElement>('#highest-quality-slider');
    if ($highestQualitySlider) {
        new Swiper($highestQualitySlider, {
            modules: [Autoplay],
            autoplay: true,
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 40,
            centerInsufficientSlides: true,
        });
    }
}
